import React from "react";
import { FieldRenderProps } from "react-final-form";
import styles from "./FileInput.module.css";

type Props = FieldRenderProps<string, any>;

const FileInput: React.FC<Props> = ({ input, meta, ...rest }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    input.onChange(file); // Pass the File object to react-final-form
  };

  return (
    <div className={styles.inputWrapper}>
      <input
        type="file"
        className={
          (meta.error || meta.submitError) && meta.touched
            ? styles.errorInputField
            : styles.inputField
        }
        onChange={handleChange}
        {...rest}
      />
      {(meta.error || meta.submitError) && meta.touched && (
        <span className={styles.errorText}>
          {meta.error || meta.submitError}
        </span>
      )}
    </div>
  );
};

export { FileInput };
